import VConsole from "vconsole";
const ModeLocal = 1;//内网测试
const ModeNetTest = 2;//外网测试
const ModeNetProduct = 3;//生产环境

var RunMode = ModeNetProduct
// var RunMode = ModeNetTest

//生产环境
let url_server_center = 'https://www.you1quan.com/center';//用户中心
let url_file_upload = 'https://www.you1quan.com/fdfs';//文件上传
let url_image_load = 'https://attach.cdn.you1quan.com/'; //加载图片
let url_server_red_packet = 'https://www.you1quan.com/packet';//红包服务
let url_server_payment = 'https://y1q.pay.xmedwin.com';//支付服务
let url_asset_operate = 'https://www.you1quan.com';//资源操作

let url_order_center = 'https://www.you1quan.com/order';//订单服务
let url_web_socket = 'wss://www.you1quan.com/ws/im';
let url_social_contact = 'https://www.you1quan.com/im';
let url_mission = 'https://www.you1quan.com/mission';
let url_php_center = 'https://s.you1quan.com';//php中心接口

// new VConsole()
//本地测试
if (RunMode == ModeLocal) {
  url_server_center = 'http://192.168.1.13:8600';
  url_file_upload = 'http://192.168.1.13:8610';
  url_image_load = 'http://192.168.1.13:8000/';
  url_server_red_packet = 'http://192.168.1.13:8620';
  url_server_payment = 'http://192.168.1.13:8630';
  url_asset_operate = 'http://192.168.1.13:8000';
  url_web_socket = 'ws://192.168.1.13:8710';
  url_social_contact = 'http://192.168.1.13:8712';
  url_order_center = 'http://192.168.1.13:8714';
  url_php_center = 'http://192.168.1.40/you1quan/public/index.php/api';//php中心接口
}
//外网测试
else if (RunMode == ModeNetTest) {//用户中心
  url_server_center = 'http://119.23.34.11/center';//用户中心
  url_file_upload = 'http://119.23.34.11/fdfs';//文件上传
  url_image_load = 'http://119.23.34.11/'; //加载图片
  url_server_red_packet = 'http://119.23.34.11/packet';//红包服务
  url_server_payment = 'http://y1q.pay.xmedwin.com';//支付服务
  url_asset_operate = 'http://119.23.34.11';//资源操作

  url_order_center = 'http://119.23.34.11/order';//订单服务
  url_web_socket = 'ws://119.23.34.11/ws/im';
  url_social_contact = 'http://119.23.34.11/im';
  url_mission = 'http://119.23.34.11/mission';  //任务
  url_php_center = 'http://dev.wzyl.77p.xyz';//php中心接口
  // new VConsole()
}


const urls = {
  ucenter: url_server_center,
  imgload: url_image_load,
  fupload: url_file_upload,
  aoperate: url_asset_operate,
  rpacket: url_server_red_packet,
  payment: url_server_payment,
  websock: url_web_socket,
  social: url_social_contact,
  ocenter: url_order_center,
  mission: url_mission,
  phpcenter: url_php_center,
}

export default urls;




// WEBPACK FOOTER //
// ./src/plugins/net-urls.js